import React, { useState } from 'react';
import { cn } from '@/lib/utils';

interface FloatingLabelWrapperProps {
  label: React.ReactNode;
  children: React.ReactElement<{
    onFocus?: (e: React.FocusEvent<Element>) => void;
    onBlur?: (e: React.FocusEvent<Element>) => void;
  }>;
  hasValue?: boolean;
  className?: string;
}

export function FloatingLabelWrapper({
  label,
  children,
  hasValue = false,
  className,
}: FloatingLabelWrapperProps) {
  const [isFocused, setIsFocused] = useState(false);
  const isFloating = isFocused || hasValue;

  // Clone the child element and add focus handlers
  const childWithHandlers = React.cloneElement(children, {
    onFocus: (e: React.FocusEvent<Element>) => {
      setIsFocused(true);
      children.props.onFocus?.(e);
    },
    onBlur: (e: React.FocusEvent<Element>) => {
      setIsFocused(false);
      children.props.onBlur?.(e);
    },
  });

  return (
    <div className={cn('relative', className)}>
      <label
        className={cn(
          'absolute left-3 transition-all duration-200 ease-out pointer-events-none z-10',
          'text-muted-foreground',
          isFloating
            ? '-top-2 text-xs bg-background px-1 text-foreground font-medium'
            : 'top-1/2 -translate-y-1/2 text-sm font-normal',
        )}
      >
        {label}
      </label>
      {childWithHandlers}
    </div>
  );
}
